export const salaryNumberToString = (value: number | null) =>
  value ? new Intl.NumberFormat("en-US").format(value) : "";

export const salaryStringToNumber = (value: string) =>
  parseInt(value.replace(/\D/g, "")) || null;
